import React, { useEffect } from "react";
import { Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import locales from "../locales.json";
import { useLang } from "../context/LangContext";
import {
  canUseGoogleAds,
  ensureGoogleTagLoaded,
  reportGoogleAdsConversion,
} from "../utils/googleAds";

const ThankYouPage = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const { payment_page } = locales;

  useEffect(() => {
    if (!canUseGoogleAds()) {
      return undefined;
    }

    if (!ensureGoogleTagLoaded()) {
      return undefined;
    }
    if (!reportGoogleAdsConversion()) {
      const timer = setTimeout(() => {
        reportGoogleAdsConversion();
      }, 500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: { xs: "100vh", md: "calc(100vh - 64px)" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: { xs: 1, sm: 2, md: 0 },
        boxSizing: "border-box",
        width: "100%",
        textAlign: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ fontSize: { xs: "1.7rem", md: "2rem" } }}
        >
          {payment_page.premium_thank_you_title[lang]}
        </Typography>
        <Typography
          variant="body1"
          sx={{ marginBottom: "16px", fontSize: { xs: "1rem", md: "1.1rem" } }}
        >
          {payment_page.premium_thank_you_text[lang]}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            borderRadius: "24px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            padding: { xs: "10px 0", md: "12px 0" },
          }}
          onClick={() => navigate("/")}
        >
          {payment_page.back_to_home[lang]}
        </Button>
      </div>
    </Container>
  );
};

export default ThankYouPage;
